export const PROMO_DESIGN = {
	HEADER: "header message promo",
	IN_LINE: "in line message bubble",
};

export const READ_RECEIPT_ANALYTICS_PROPS = {
	"promo id": "readreceipt.messenger",
	feature: "readreceipt",
	source: "message thread",
};



// WEBPACK FOOTER //
// ./src/analytics/read_receipts.js